import LiveTypePreview from "../../components/LiveTypePreview/LiveTypePreview";
import { useStore } from "../../store/store";
import "./LivePlayer.css";
import { useTranslation } from "react-i18next";

interface IProps {
  type?: "before" | "after";
}

const LiveStatusIndicator = ({ type = "before" }: IProps) => {
  const startDate = useStore((state) => state.startDate);
  const endDate = useStore((state) => state.endDate);
  const live = useStore((state) => state.live);
  const skinInfos = useStore((state) => state.skinInfos);
  const { t } = useTranslation();

  const isRte = window.process.env.CLIENT_NAME.includes("rte");
  const isBefore = type === "before";

  /* -------------------------------
   * Skin configuration
   * ------------------------------- */
  const textOptions = isBefore
    ? skinInfos?.beforeLiveTextOptions
    : skinInfos?.afterLiveTextOptions;

  const backgroundImage = isBefore
    ? skinInfos?.beforeBackground
    : skinInfos?.afterBackground;

  const isBlurred = isBefore
    ? skinInfos?.bluredBeforeBackground
    : skinInfos?.bluredAfterBackground;

  const hasBackgroundImage = Boolean(backgroundImage);



  /* -------------------------------
   * Text visibility
   * ------------------------------- */
  const showDate =
  (textOptions?.date ?? true) && !!startDate && isBefore;

const showDuration =
  (textOptions?.duration ?? true) && !!endDate && isBefore;

  return (
    <div className="aspect-video w-full flex-grow md:h-auto md:max-h-full md:w-auto">
      <div className="relative mx-auto aspect-video w-full rounded-lg overflow-hidden playerDiv">
        
        {/* Background layer */}
        <div
          className="absolute inset-0 bg-rte"
          style={{
            backgroundImage: hasBackgroundImage
              ? `url(${backgroundImage})`
              : undefined,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: hasBackgroundImage && isBlurred ? "blur(5px)" : "none",
            // transform: "scale(1.05)", // prevents blur edges
          }}
        />

        {/* Dark overlay for contrast */}
        {hasBackgroundImage && isBlurred && (
          <div className="absolute inset-0 bg-black/30" />
        )}

        {/* Content layer (NOT blurred) */}
        <div className="relative z-10 flex h-full w-full items-center justify-center px-4 text-center">
          {isRte && live?.types?.length ? (
            <LiveTypePreview type={live.types[0]} />
          ) : (
			<div className="flex flex-col items-center gap-3">
			  {!isBefore && !textOptions?
									<h2 className="text-center text-lg text-primary sm:text-xl lg:text-2xl">{t("live_page.live_over")}</h2>
:
				<h2
				className="text-primary font-semibold"
				style={{ fontSize: "clamp(1.5rem, 1vw, 1.8rem)" }}
			  >
				{textOptions?.title}
			  </h2>}

			{showDate && (
			  <h2
				className="text-primary"
				style={{ fontSize: "clamp(0.75rem, 1vw, 1.25rem)" }}
			  >
				{startDate}
			  </h2>
			)}

			{showDuration && (
			  <h2
				className="text-primary"
				style={{ fontSize: "clamp(0.75rem, 1vw, 1.25rem)" }}
			  >
				{endDate}
			  </h2>
			)}
		  </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LiveStatusIndicator;
